import { gql, type TypedDocumentNode } from "@apollo/client";
import { type GQL } from "@binale-tech/shared";

export const taxPrepaymentsQuery: TypedDocumentNode<
    Pick<GQL.IQuery, "taxPrepayments">,
    GQL.IQueryTaxPrepaymentsArgs
> = gql`
    query taxPrepayments($companyId: ID!) {
        taxPrepayments(companyId: $companyId) {
            id
            companyId
            taxType
            quarterlyAmountCents
            validFromYear
            note
            docRef
            createdBy
            createdAt
            updatedAt
        }
    }
`;
